export const New = () => import("./New.vue");
export const Edit = () => import("./Edit.vue");
export const Show = () => import("./Show.vue");
export const Card = () => import("./Card.vue");
export const ShowAllCard = () => import("./ShowAllCard.vue");
export const List = () => import("./List.vue");
export const Create = () => import("./Create.vue");
export const Current = () => import("./Current.vue");
export const OldEntry = () => import("./OldEntry.vue");
export const AdminList = () => import("./AdminList.vue");
export const EarlyJoin = () => import("./EarlyJoin.vue");
export const BulkCreate = () => import("./BulkCreate.vue");
export const Correction = () => import("./Correction.vue");
export const ApprovedList = () => import("./ApprovedList.vue");
export const LeaveExtension = () => import("./LeaveExtension.vue");
export const ShowCorrection = () => import("./ShowCorrection.vue");
